import { LoginStyled } from "../../Styles/Login";
import logoBranca from "../../Assets/Logos/logotipo_BRK.svg";
import { FormLogin } from "./FormeLogin";

export const Login = () => {
  return (
    <LoginStyled>
      <div className="formLogin">
        <FormLogin />
      </div>
      <div className="LogoBranca">
        <img src={logoBranca} />
      </div>
    </LoginStyled>
  );
};
